// onload works on older iOS/webviews too, without relying on Image.decode().
export const loadPhotoImage = (url, signal, timeoutMs = 20000) => new Promise((resolve, reject) => {
  const image = new Image(); let settled = false;
  const finish = error => {
    if (settled) return; settled = true;
    clearTimeout(timer); signal?.removeEventListener('abort', abort);
    image.onload = image.onerror = null;
    if (error) { image.src = ''; reject(error); } else resolve(image);
  };
  const abort = () => finish(new DOMException('Photo loading cancelled.', 'AbortError'));
  const timer = setTimeout(() => finish(new Error('Your photo took too long to open. Please try again.')), timeoutMs);
  image.onload = () => finish(image.naturalWidth && image.naturalHeight ? null : new Error('This photo could not be displayed. Choose another photo.'));
  image.onerror = () => finish(new Error('This photo could not be displayed. Choose another photo.'));
  if (signal?.aborted) { abort(); return; }
  signal?.addEventListener('abort', abort, { once: true });
  image.src = url;
});